// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1R2E3","bigColWidth":"Table_bigColWidth__1z6bQ","biggerColWidth":"Table_biggerColWidth__13FBe","row":"Table_row__3g5ln","col":"Table_col__1HP_8"};